import React from 'react'
import { get } from 'lodash'

import EventForm from './EventForm'

import Modal from 'Components/Modal'

const EventModal = ({
  onClose,
  event,
  processingEvent,
  ...eventFormProps
}) => (
  <Modal
    title={`${get(event, 'meta.id') ? 'Update' : 'New'} Task`}
    removeModal={onClose}
    processing={processingEvent}
  >
    <EventForm {...{ ...eventFormProps, event }} />
  </Modal>
)

export default EventModal
